import React from 'react';
import { Panel } from 'react-bootstrap';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const List = ({ isReadonly, t, canSendMessage, listActions, ...rest }) => {
	const columns = [
		{
			header: t('WaitingList_Child'),
			accessor: 'child.name',
			cell: (child, row) => (<Link to={`/parents/${row.parent.id}/children/${row.child.id}`} > {row.child.name}</Link>),
			sortable: true
		},
		{
			header: t('WaitingList_Child_Age'),
			accessor: 'child.dateOfBirth',
			cell: (dateOfBirth, row) => <span>{ui.formatAge(row.child.dateOfBirth)}</span>,
			sortable: true
		},
		{
			header: t('WaitingList_Parent'),
			accessor: 'parent.name',
			cell: (parent, row) => (<Link to={`/parents/${row.parent.id}`} > {row.parent.name}</Link>),
			sortable: true
		},
		{
			header: t('WaitingList_Email'),
			accessor: 'parent.email',
			sortable: true
		},
		{
			header: t('WaitingList_Phone'),
			accessor: 'parent.phoneNumber',
			sortable: true
		},
		{
			header: t('WaitingList_Grade'),
			accessor: 'weeklyProgram',
			sortable: true
		},
		{
			header: t('WaitingList_Date'),
			accessor: 'startDate',
			cell: (startDate) => (ui.formatDate(startDate)),
			sortable: true
		},
		{
			header: t('WaitingList_Created'),
			accessor: 'created',
			cell: (created) => ui.formatDateTime(created),
			sortable: true
		},
		{
			header: t('WaitingList_Status'),
			accessor: 'statusName',
			cell: (statusName) => t(`WaitingListStatusType_${statusName}`),
			sortable: true
		}
	];

	if (!isReadonly) {
		columns.push({
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => (<Link to={`/waitingList/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('WaitingList_ChangeStatus')}</Link>)
		})
	}
	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} checkboxSelection={canSendMessage} listActions={listActions} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);